import React, { useEffect, useState } from 'react';
import LogCannon from '@ace-clublabs/log-cannon';
import { TeamValue, WorkloadValue } from '@ace-clublabs/aws-tags';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@ace-clublabs/shared-component-library';
import { Header } from './components/Header';
import Router from './components/Router';
import './styles/main.scss';
import { autoPayEnrollmentPath, basePath } from './utils/constants';
import { setGlobalState, useGlobalState } from './shared/state';
import { getQueryProps } from './utils/useQueryParamsHooks';

const setIsMobileApp = (isMobileApp: boolean): void => setGlobalState('isMobileApp', isMobileApp);
const setQueryProps = (queryProps: any) => setGlobalState('queryProps', queryProps);

const App: React.FC = () => {
  const [queryProps, setLocalQueryProps] = useState({});
  const [isMobileApp] = useGlobalState('isMobileApp');
  const paramsFromUrl: any = getQueryProps();
  const path = window.location.pathname;

  let base_url;
  let appName: string;
  if (path && path.startsWith(autoPayEnrollmentPath)) {
    base_url = autoPayEnrollmentPath;
    appName = 'membership-apwol';
    document.title = 'AAA | Enroll in Auto Pay';
  } else {
    base_url = basePath;
    appName = 'membership-pwol';
    document.title = 'AAA | Make a payment';
  }

  const apiKey = '6ZFMpmfOnFME0KeYvJfz3a8G8Fh8qx';

  LogCannon.init(apiKey, {
    team: TeamValue.Membership,
    workload: WorkloadValue.MembershipManagement,
    component: appName,
    runtime: 'browser',
    runtimeVersion: '22.0.0',
  } as any);

  useEffect(() => {
    if (!window.location.hostname.includes('aaa.com')) return;

    const updatedProps: any = { ...queryProps };
    const { pathname } = window?.location;

    Object.entries(paramsFromUrl).forEach(([key, value]) => {
      updatedProps[key as any] = value;
    });
    setLocalQueryProps(updatedProps);
    setQueryProps(updatedProps);

    if (updatedProps.mobileapp === 'true') {
      setIsMobileApp(true);
    }

    if (window?.location?.hostname?.endsWith('.aaa.com') && [basePath, autoPayEnrollmentPath].includes(pathname)) {
      const zipRouterScript = document.createElement('script');
      zipRouterScript.src = 'https://app.ace.aaa.com/ziprouter/1.0.5/ace-zip-router.js';
      zipRouterScript.type = 'text/javascript';
      zipRouterScript.id = 'zip-router-modal-script';
      document.body.appendChild(zipRouterScript);
    }
  }, []);

  return (
    <>
      <BrowserRouter basename={base_url}>
        {isMobileApp ? <div style={{ marginTop: 24 }} /> : <Header />}
        <ThemeProvider>
          <div role="main" className="container">
            <Router />
            {/* <h2>Thank you for visiting AAA.</h2>
          <p>
            Please be advised that the service you are looking for is temporarily unavailable as we optimize the website
            experience to better serve your needs.
          </p>

          <p>
            We apologize for any inconvenience and thank you for your patience. For the AAA website, please visit us at
            http://www.aaa.com.
          </p> */}
          </div>
        </ThemeProvider>
      </BrowserRouter>
    </>
  );
};

export default App;
